/**
 * Subscription status codes as returned by the API.
 *
 * Lives in its own module rather than beside the checkout form: it's an enum,
 * so importing it is a *value* import, and `useStripeCheckoutResponse` —
 * which is mounted globally in `_app` — was pulling the entire checkout form
 * (Stripe Elements, pricing hooks, card form) into the main bundle just to
 * read these numbers (DEV-6485).
 */
export enum SubscriptionStatusCode {
  ACTIVE = 1,
  DORMANT = 2,
  SUSPENDED = 3,
  TRIAL = 4,
  INITIATED = 5,
  FAILED_INITIATION = 6,
  PAUSED = 7,
  CHURNED_VOLUNTARY = 8,
  CHURNED_INVOLUNTARY = 9,
}
